import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { createContext } from 'react';

import themeMock from '../__mocks__/kioskPackages/theme.json';
import { usePrimaryColor } from '../hooks/usePrimaryColor';
import type { Theme } from './types';

interface ThemeContextType {
  theme: Theme;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: themeMock[0],
});

export const ThemeProviderCustomized: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const primaryColor = usePrimaryColor();

  const root = document.querySelector(':root') as HTMLElement;
  root.style.setProperty('--theme_primary', primaryColor);

  const buttonsTheme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
    },
  });
  return <ThemeProvider theme={buttonsTheme}>{children}</ThemeProvider>;
};
